'use strict';
const angular = require('angular');
const uiRouter = require('angular-ui-router');

import routes from './html-source.routes';

let ace: any = window['ace']; // Global instance of ACE

export class HtmlSourceComponent {
  radioModel: any;
  store: any;
  formhtml: any;

  /*@ngInject*/
  constructor(localStorage) {
    this.store = localStorage;
    this.radioModel = 'HTML';
    this.formhtml = this.store.get('formhtml');
  }

  /* ACE editor on loaded callback */
  aceLoaded(_editor) {
    // Editor part
    var _session = _editor.getSession();
    var _renderer = _editor.renderer;

    // Setting theme
    _editor.setTheme('ace/theme/xcode');

    // Options
    _editor.setReadOnly(false);
    _session.setUndoManager(new ace.UndoManager());
    _renderer.setShowGutter(true);

    // Events
    _editor.on('changeSession', function(){  });
    _session.on('change', function(){  });

  }
}

export default angular.module('nodeApp.create.html-source', [uiRouter])
  .config(routes)
  .component('htmlSource', {
    template: require('./html-source.html'),
    controller: HtmlSourceComponent,
    controllerAs: 'htmlSourceCtrl'
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/create/html-source/html-source.component.ts